// import React, {useState, useEffect} from 'react';
// import {
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
// } from '@mui/material';
// import Collapse from '@mui/material/Collapse';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import {Link} from 'react-router-dom';
// import {EvaluarPermiso} from '../../Genericos/Generales';

// const Marketing = props => {

//   const classes = props.classes;
//   const sesionUsuario = props.sesionUsuario;

//   useEffect (() => {
//     VerificarPermisos (
//       sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//     );
//   }, [sesionUsuario]);

//   const [marketing, setMarketing] = useState(false);
//   const [campanas, setCampanas] = useState(false);
//   const [metricas, setMetricas] = useState(false);
//   const [correosMasivos, setCorreosMasivos] = useState(false);

//   const [openMarketing, setOpenMarketing] = useState(false);
//   const handleOpenMarketing = () => {
//     setOpenMarketing(!openMarketing);
//   };

//   const VerificarPermisos = arrPermisos => {
//     setMarketing(EvaluarPermiso(arrPermisos, '/marketing'));
//     setCampanas(EvaluarPermiso(arrPermisos, '/campanasPrincipal'));
//       setMetricas(EvaluarPermiso(arrPermisos, '/metricas'));
//       setCorreosMasivos(EvaluarPermiso(arrPermisos, '/correosMasivos'));
      
//   };

//   return (
//     <React.Fragment>
//         {marketing ? (
//         <List>
//           <ListItem onClick={handleOpenMarketing}>
//             <i notranslate="true" className="material-icons">
//               public
//             </i>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Marketing"
//             />
//             {openMarketing ? <ExpandLess /> : <ExpandMore />}
//           </ListItem>
//           <Collapse in={openMarketing} timeout="auto" unmountOnExit>
//             <List component="div" disablePadding>
//               {campanas ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/campanasPrincipal"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     campaign
//                   </i>
//                   <ListItemText primary="Campañas" />
//                 </ListItem>
//               ) : null}
//             </List>
//             <List component="div" disablePadding>
//               {metricas ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/metricas"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     show_chart
//                   </i>
//                   <ListItemText primary="Metricas" />
//                 </ListItem>
//               ) : null}
//               {correosMasivos ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/correosMasivos"
//                   className={classes.listItemText}
//                 >
//                   <span class="material-icons">alternate_email</span>
//                   <ListItemText primary="Correos Masivos" />
//                 </ListItem>
//               ) : null}
//             </List>
//           </Collapse>
//         </List>
//       ) : null}
//       {marketing ? <Divider /> : null}
//     </React.Fragment>)}

//     export default Marketing
import React, { useState, useEffect } from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PublicIcon from '@mui/icons-material/Public';
import CampaignIcon from '@mui/icons-material/Campaign';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import { Link } from 'react-router-dom';
import { EvaluarPermiso } from '../../Genericos/Generales';
import { menuItemStyles } from '../../Tools/MenuItemStyles';

const Marketing = ({ sesionUsuario }) => {
  const [marketing, setMarketing] = useState(false);
  const [campanas, setCampanas] = useState(false);
  const [metricas, setMetricas] = useState(false);
  const [correosMasivos, setCorreosMasivos] = useState(false);

  const [openMarketing, setOpenMarketing] = useState(false);
  const handleOpenMarketing = () => {
    setOpenMarketing(!openMarketing);
  };

  useEffect(() => {
    const permisos = sesionUsuario.usuario.pantallasUsuario.listaPantallasRol;
    setMarketing(EvaluarPermiso(permisos, '/marketing'));
    setCampanas(EvaluarPermiso(permisos, '/campanasPrincipal'));
    setMetricas(EvaluarPermiso(permisos, '/metricas'));
    setCorreosMasivos(EvaluarPermiso(permisos, '/correosMasivos'));
  }, [sesionUsuario]);

  return (
    <>
      {marketing && (
        <>
          <ListItem
            button
            onClick={handleOpenMarketing}
            sx={menuItemStyles.expandableHeader}
          >
            <ListItemIcon sx={menuItemStyles.menuIcon}>
              <PublicIcon />
            </ListItemIcon>
            <ListItemText
              primary="Marketing"
              sx={menuItemStyles.menuText}
            />
            {openMarketing ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openMarketing} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {campanas && (
                <ListItem
                  button
                  component={Link}
                  to="/campanasPrincipal"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <CampaignIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Campañas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {metricas && (
                <ListItem
                  button
                  component={Link}
                  to="/metricas"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ShowChartIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Metricas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {/* {correosMasivos && (
                <ListItem
                  button
                  component={Link}
                  to="/correosMasivos"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <AlternateEmailIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Correos Masivos"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )} */}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
};

export default Marketing;
